(() => {
  const DRAWER_SEARCH_ID = "mobe-drawer-search";

  function buildDrawerSearchFromDawn() {
    // Drawer container
    const drawer = document.querySelector("#menu-drawer .menu-drawer__navigation-container");
    if (!drawer) return;

    // Prevent duplicates
    if (drawer.querySelector(`#${DRAWER_SEARCH_ID}`)) return;

    // Source: Dawn search modal predictive-search (desktop header)
    const sourcePredictive = document.querySelector(
      "details-modal.header__search predictive-search"
    );
    if (!sourcePredictive) return;

    // Clone Dawn predictive-search block
    const clone = sourcePredictive.cloneNode(true);

    // Make IDs unique to avoid breaking header search
    // (Dawn uses these IDs for aria-controls and predictive-search results)
    const html = clone.outerHTML
      .replaceAll("Search-In-Modal", "Search-In-Drawer")
      .replaceAll('for="Search-In-Modal"', 'for="Search-In-Drawer"')
      .replaceAll("predictive-search-results", "predictive-search-results-drawer")
      .replaceAll('aria-controls="predictive-search-results"', 'aria-controls="predictive-search-results-drawer"')
      .replaceAll('aria-owns="predictive-search-results"', 'aria-owns="predictive-search-results-drawer"');

    // Wrapper inserted in drawer
    const wrapper = document.createElement("div");
    wrapper.id = DRAWER_SEARCH_ID;
    wrapper.className = "menu-drawer__search"; // Dawn-ish class hook
    wrapper.innerHTML = html;

    // Insert at the very top of drawer content
    drawer.prepend(wrapper);
  }

  // Run once on load + whenever drawer is opened (Shopify/Dawn toggles DOM states)
  document.addEventListener("DOMContentLoaded", buildDrawerSearchFromDawn);
  document.addEventListener("click", (e) => {
    // If user tapped the hamburger, drawer opens -> ensure search exists
    const summary = e.target.closest("#Details-menu-drawer-container > summary");
    if (summary) setTimeout(buildDrawerSearchFromDawn, 0);
  });

  // Also react to <details> open/close
  const details = document.querySelector("#Details-menu-drawer-container");
  if (details) {
    details.addEventListener("toggle", () => {
      if (details.open) setTimeout(buildDrawerSearchFromDawn, 0);
    });
  }
})();

/* ==========================================================================
   Side cart : le bouton close se superpose au bouton d'ouverture du panier.
   Le panneau s'ouvre sans que le point de clic bouge.

   Pourquoi une mesure au runtime plutot que des offsets CSS :
   - vertical : le header est en position: fixed sous la barre d'annonce, donc
     sa position depend de la presence de la barre, du nombre de lignes qu'elle
     occupe, et de l'etat de scroll (la barre se retracte, le header remonte) ;
   - horizontal : sur mobile le bouton panier n'est PAS colle a droite, le
     libelle « Menu » vient apres lui. L'ecart depend donc de la largeur rendue
     d'un texte.
   Aucune des deux n'est exprimable en dur sans casser des qu'un de ces
   parametres change. On copie donc la boite du bouton d'ouverture.

   Le bouton close reste positionne en absolute dans .drawer__header : il glisse
   avec le panneau et reste dans le role="dialog" (donc dans le piege de focus).
   Les variables posees sont des offsets par rapport a ce conteneur.
   Consomme par .drawer__close dans custom.css.
   ========================================================================== */
(() => {
  // Comportement desktop uniquement : en mobile la croix reste calee en haut a
  // droite du panneau. C'est la media query de custom.css qui fait foi ; ce
  // test evite seulement de mesurer pour rien sur mobile.
  const DESKTOP = "(min-width: 990px)";

  function syncCartCloseToOpener() {
    if (!window.matchMedia(DESKTOP).matches) return;

    const opener = document.getElementById("cart-icon-bubble");
    const drawer = document.querySelector("cart-drawer");
    if (!opener || !drawer) return;

    const inner = drawer.querySelector(".drawer__inner");
    const head = drawer.querySelector(".drawer__header");
    if (!inner || !head) return;

    const openRect = opener.getBoundingClientRect();
    const style = document.documentElement.style;

    // Le bouton d'ouverture doit etre a l'ecran pour servir de cible. S'il est
    // masque (display none) ou hors viewport — cas d'un header escamote au
    // scroll, avec un panier ouvert par un ajout produit — s'aligner dessus
    // enverrait le bouton close hors de l'ecran, donc hors d'atteinte. On rend
    // alors la main au repli CSS (coin haut droit du panneau).
    const onScreen =
      openRect.width > 0 &&
      openRect.height > 0 &&
      openRect.bottom > 0 &&
      openRect.right > 0 &&
      openRect.top < window.innerHeight &&
      openRect.left < window.innerWidth;

    if (!onScreen) {
      style.removeProperty("--mobe-cart-close-top");
      style.removeProperty("--mobe-cart-close-left");
      style.removeProperty("--mobe-cart-close-width");
      style.removeProperty("--mobe-cart-close-height");
      return;
    }

    // .drawer__inner porte le transform de glissement du panneau (translateX
    // 100% -> 0). Ce transform en fait le bloc conteneur de ses descendants
    // positionnes, et decale son rect selon l'avancement de l'animation. On
    // retire la translation courante pour retrouver la position de
    // .drawer__header panneau ouvert : la mesure est alors juste quel que soit
    // le moment ou on la prend (panneau ferme, en cours d'ouverture, ouvert).
    const transform = getComputedStyle(inner).transform;
    let shiftX = 0;
    let shiftY = 0;
    if (transform && transform !== "none") {
      const matrix = new DOMMatrixReadOnly(transform);
      shiftX = matrix.m41;
      shiftY = matrix.m42;
    }

    // On n'accepte que les frames ou le panneau est a l'arret : ferme
    // (translateX = sa largeur) ou ouvert (0). Un transform en transition est
    // anime par le compositeur, alors que getComputedStyle lit le thread
    // principal : les deux peuvent renvoyer des etats decales d'une frame, ce
    // qui donne une correction fausse et un bouton pose loin de sa cible. La
    // boucle de suivi repasse a la frame suivante, et tourne assez longtemps
    // pour se terminer sur des frames stables.
    const closedShift = inner.offsetWidth;
    const settled = Math.abs(shiftX) < 0.5 || Math.abs(shiftX - closedShift) < 0.5;
    if (!settled) return;

    const headRect = head.getBoundingClientRect();
    style.setProperty("--mobe-cart-close-top", openRect.top - (headRect.top - shiftY) + "px");
    style.setProperty("--mobe-cart-close-left", openRect.left - (headRect.left - shiftX) + "px");
    style.setProperty("--mobe-cart-close-width", openRect.width + "px");
    style.setProperty("--mobe-cart-close-height", openRect.height + "px");
  }

  // Le header peut etre en train de bouger au moment de l'ouverture : quand la
  // barre d'annonce se retracte au scroll, son `top` est anime (150 ms). Une
  // mesure unique prise pendant cette transition figerait une position
  // intermediaire. On re-mesure donc a chaque frame pendant l'ouverture, le
  // temps que header et panneau se stabilisent. Borne dans le temps : rien ne
  // tourne en dehors de l'ouverture.
  const SETTLE_MS = 400; // > transition du header (150) et glissement du panneau (200)
  function syncUntilSettled() {
    const start = performance.now();
    const step = (now) => {
      syncCartCloseToOpener();
      if (now - start < SETTLE_MS) requestAnimationFrame(step);
    };
    syncCartCloseToOpener();
    requestAnimationFrame(step);
  }

  // Mesure au pointerdown, en capture : on passe avant le handler d'ouverture
  // de Dawn, donc les coordonnees sont posees avant que le panneau soit visible
  // (pas de saut) et elles correspondent a l'endroit exact du clic.
  document.addEventListener(
    "pointerdown",
    (event) => {
      if (event.target.closest && event.target.closest("#cart-icon-bubble")) syncUntilSettled();
    },
    true
  );

  // Ouvertures qui ne passent pas par un clic sur le bouton (ajout au panier,
  // touche Espace, notification) : cart-drawer.js pose la classe active.
  let observed = null;
  function observeDrawer() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || drawer === observed) return;
    observed = drawer;
    new MutationObserver(() => {
      if (drawer.classList.contains("active")) syncUntilSettled();
    }).observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }

  window.addEventListener("resize", syncCartCloseToOpener);
  // Editeur de theme : la section panier est re-rendue, l'element observe change.
  document.addEventListener("shopify:section:load", () => {
    observed = null;
    observeDrawer();
    syncCartCloseToOpener();
  });

  observeDrawer();
  syncCartCloseToOpener();
})();

